import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-scroll';

import IconAvatar from '@components/Images/Rebranding/IconAvatar';
import IconOpenTo from '@components/Images/Rebranding/IconOpenTo';
import IconPencil from '@components/Images/Rebranding/IconPencil';
import IconSettings from '@components/Images/Rebranding/IconSettings';
import IconSocial from '@components/Images/Rebranding/IconSocial';
import IconTopic from '@components/Images/Rebranding/IconTopic';
import IconWeekend from '@components/Images/Rebranding/IconWeekend';

const SideNav = () => {
  return (
    <Col className="SideNav col-sm-12 col-md-2 profile-detail-nav">
      <ul className="profile-settings-nav">
        <li>
          <Link className="link-nav" activeClass="active" to="Settings" spy={true} smooth={true}>
            <IconSettings className="w-20" /> Settings
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Profile" spy={true} smooth={true}>
            <IconAvatar className="w-24" /> Profile
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Open-To" spy={true} smooth={true}>
            <IconOpenTo className="w-16" /> Open To
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Social" spy={true} smooth={true}>
            <IconSocial className="w-[22px]" /> Social
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Topics" spy={true} smooth={true}>
            <IconTopic className="w-24" /> Topics
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Skills" spy={true} smooth={true}>
            <IconPencil className="w-20" /> Skills
          </Link>
        </li>
        <li>
          <Link className="link-nav" activeClass="active" to="Weekend" spy={true} smooth={true}>
            <IconWeekend className="w-24" /> Weekend
          </Link>
        </li>
      </ul>
    </Col>
  );
};

export default SideNav;
